// extracted by mini-css-extract-plugin
export var highlightFade = "_1x-4";
export var highlighted = "_1x-3";
export var table = "_1x-1";
export var tableContainer = "_1x-0";
export var totalsRow = "_1x-2";